import {Card} from "@mui/material";
import {DataGrid} from "@mui/x-data-grid";
import {formatDate} from "../../../core/utils/constants";
import {useGetLevelsV1CMQuery} from "../../../core/api/clockmaker-analytical-data-api";
import Loading from "../../../components/Common/Loading";
import { useState } from "react"


const columns = [
    {field: 'groupId', headerName: 'Group ID', flex: 1},
    {field: 'levelId', headerName: 'Level ID', flex: 1},
    {field: 'result', headerName: 'Result', flex: 1},
    {field: 'attempts', headerName: 'Attempts', flex: 1},
    {field: 'timestamp', headerName: 'Timestamp', flex: 1},
    {field: 'version', headerName: 'Version', flex: 1}
];

export default function Levels(props) {
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 100
    })

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        isFetching,
        error
    } = useGetLevelsV1CMQuery({
        "userId": props.deviceId,
        "depth": props.depth,
        "page": paginationModel.page,
        "limit": paginationModel.pageSize
    }, {
        skip: !props.deviceId || props.deviceId.trim() === ""
    })

    return (<>
        <Card>
            <Loading isLoading={isLoading||isFetching} error={error} isError={isError}>
                {data!=undefined && <DataGrid
                    getRowId={(row) => row.id}
                    rowHeight={82}
                    autoHeight={true}
                    rows={data}
                    rowCount={-1}
                    pagination={true}
                    paginationMode="server"
                    pageSizeOptions={[100]}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    columns={columns}
                />
                }
            </Loading>
        </Card>
    </>);
}
